export const PHASE = {
  LOCAL: 'local',
  SANDBOX: 'sandbox',
  CBT: 'cbt',
  BETA: 'beta',
  REAL: 'real'
};
